// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2021 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const ageGroup = `In distributions by age, individuals are counted towards the
age group they fall into as of the reporting date.`;

export const gender = `Gender distributions only include male and female due to
low numbers of other reported genders.`;

export const raceOrEthnicity = `Distributions by race count individuals with more than
one reported race or ethnicity towards the racial or ethnic identity that is least
represented in the general population.`;
